import { AuthGuard } from '../../shared/services';
import { CitizensForImpactListRoutes } from './citizens-for-impact-list/citizens-for-impact-list.routes';
import { CitizensForImpactComponent } from './citizens-for-impact.component';
import { Route } from '@angular/router';

export const CitizensForImpactRoutes: Route[] = [
  {
    path: 'citizens-for-impact',
    component: CitizensForImpactComponent,
    canActivate: [AuthGuard],
    children: [
      ...CitizensForImpactListRoutes
    ]
  }
];
